import React, { memo, useEffect } from "react";
import {
  fetchAllFilters,
  fetchFilter,
  selectAllFilters,
  selectLoading,
  setFilter,
  setFilters,
} from "features/admin/Filters/filtersAdminSlice";
import { batch, useDispatch, useSelector } from "react-redux";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
import AddFilter from "features/admin/Filters/actions/AddFilters";

interface AllFiltersTableProps {
  objectType: string;
}
const columns: ColDef[] = [
  { sortable: false, field: "title", headerName: "Име", width: 700 },
];

const FiltersTable: React.FC<AllFiltersTableProps> = ({ objectType }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector(selectAllFilters);
  const isLoading = useSelector(selectLoading);
  const [modalProps, setModalProps] = React.useState({ open: false, id: "" });

  useEffect(() => {
    dispatch(fetchAllFilters(objectType));
    return () => {
      batch(() => {
        dispatch(setFilters([]));
        dispatch(setFilter(undefined));
      });
    };
  }, [dispatch]);

  const refresh = () => {
    batch(() => {
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(fetchAllFilters(objectType));
    });
  };

  const edit = (id: string) => {
    const _refId = data.find((item: { id: number }) => item.id === parseInt(id))
      ?.refId;
    batch(() => {
      dispatch(setResponseMessage({ message: "", hasError: false }));
      dispatch(fetchFilter(_refId));
    });

    _refId && setModalProps({ open: true, id: _refId });
  };

  return (
    <>
      <GridTable
        refresh={refresh}
        edit={edit}
        data={data}
        columns={columns}
        isLoading={isLoading}
        searchProperty="title"
      />
      <AddFilter props={modalProps} setModalProps={setModalProps} />
    </>
  );
};

export default memo(FiltersTable);
